import React from 'react'
import { Flex, FlexProps, Icon, IconProps, Text } from '@clear/design-system'

type BannerAlertProps = {
  className?: string
  iconProps?: IconProps
} & FlexProps

export default function BannerAlert({
  children,
  iconProps,
  ...props
}: BannerAlertProps) {
  return (
    <Flex data-testid="banner-alert" p={4} justifyContent="center" {...props}>
      <Text color="neutralsWhite" width="100%">
        <Flex className="gap-3">
          {iconProps && <Icon data-testid="banner-icon" {...iconProps} />}
          {children}
        </Flex>
      </Text>
    </Flex>
  )
}
